import { FC } from 'react';

import { PurchasesDeliveryDetails } from './PurchasesDeliveryDetails';
import { Order } from '../../../types';

export const SalesDeliveryInfo: FC<{ order: Order }> = ({ order }) => {
    if (order.status === 'pending' || order.status === 'paid') {
        return null;
    }

    return <PurchasesDeliveryDetails order={order} showCopyActions />;
};
